import { object, string, TypeOf } from 'yup';

export const ListUserTemplateFilterSchema = object({
  username: string(),
});

export type ListUserTemplateFilterType = TypeOf<
  typeof ListUserTemplateFilterSchema
>;
